<template>
<div>
  <div class="box-header title-boreder">
      <h3 class="box-title title"> Reglas <h3 class="box-title title" style="">
        <span v-if="this.currentRule === null" class="table-btn-icon"></span></h3><span v-if="this.currentRule === null"> Registro</span> <h3 v-if="this.currentRule !== null" class="box-title title" style=""><span class="table-btn-icon"></span></h3>
        <h3 v-if="this.currentRule !== null" :to="{ name: 'AlertRules', params: { accountCode: this.selectedAccount.code } }" class="box-title title">{{this.selectedAccount.name}}</h3>
        <h3 v-if="this.currentRule !== null" class="box-title title" style=""><span class="table-btn-icon"></span></h3>
        <h3 v-if="this.currentRule !== null" class="box-title title" > {{this.currentRule.Name}}</h3>
      </h3>
    </div>
  <div class="box box-success">
        <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub"><img class="icon-space" src="/static/img/icons/exclamation-circle-solid-modal.png"> Crear Regla</h3>
    </div>
    <form @submit.prevent="handleSubmit" autocomplete="off">

      <div class="box-body">

      <div class="filterContainer">
        <div class="row">
          <div class="col-md-4"  style="padding-bottom:20px">      
            <div id="divAccountSelect" class="form-group" v-if="this.currentRule === null">
              <label>Cuenta</label>  
              <multiselect
                :value="this.selectedAccount"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                track-by="name"
                :placeholder="this.selectedAccount.name"
                :allow-empty="false"
                label="name"
                :options="this.optionsAccount"
                @input="onAccountSelect">
                <span slot="noResult">
                  No se encontraron resultados
                </span>
              </multiselect>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">  
              <label for="ruleName">Nombre</label>  
              <input id="ruleName" v-model="ruleName" type="text" class="form-control">
              <div v-show="submitted && ruleName === ''" class="invalid-feedback">Nombre Requerido</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">      
            <div class="form-group">  
              <label for="ddlItemType">Criterio</label>  
              <select id="ddlItemType" v-model="ruleItemType" class="form-control">
                <option v-for="item in this.optionsItemType" v-bind:key="item.code" v-bind:value="item.code">
                  {{ item.name }}
                </option>
              </select>
              <div v-show="submitted && !ruleItemType" class="invalid-feedback">Tipo Requerido</div>
            </div>
          </div>
          <div class="col-md-3">      
            <div class="form-group">  
              <label for="txtItemCode">Código</label>
              <input id="txtItemCode" type="text" class="form-control" v-model="ruleItemCode"/>
              <div v-show="submitted && !ruleItemCode" class="invalid-feedback">Código Requerido</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">      
            <div class="form-group">  
              <label for="ddlOperator">Operador</label>  
              <select id="ddlOperator" v-model="ruleOperator" class="form-control">
                <option v-for="item in this.optionsOperator" v-bind:key="item.code" v-bind:value="item.code">
                  {{ item.name }}
                </option>
              </select>
              <div v-show="submitted && !ruleOperator" class="invalid-feedback">Operador Requerido</div>
            </div>
          </div>
          <div class="col-md-3">      
            <div class="form-group">  
              <label for="numValue">Valor</label>
              <input id="numValue" v-model="ruleValue" type="number" min="0" class="form-control"/>
              <div v-show="submitted && ruleValue <= 0" class="invalid-feedback">Valor Requerido</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">      
            <div class="form-group">  
              <label for="txtEmail">Correos de Nottificación</label>  
              <textarea  id="txtEmail" v-model="notifyToValue" class="form-control" type="textarea" rows="4" />
              <div v-show="submitted && notifyToValue.trim() === ''" class="invalid-feedback">Correo Requerido</div>
              <span>*Ingrese múltiples correos separados por ";" (Punto y Coma)</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <input  v-bind:class="['btn btn-success', { 'disabled' : (submitted && !selectedAccount && !selectedEriType && !selectedDate && !squaredSkuCount && !inventoriedSkuCount) }]" 
                    type="submit" 
                    :value="this.currentRule === null ? 'Registrar' : 'Actualizar'"
            >
          </div>
        </div>
      </div>
      </div>
    </form>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import 'bootstrap-daterangepicker/daterangepicker.css'
import 'bootstrap-daterangepicker/daterangepicker.js'
import Modal from 'components/modal/Modal.vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'AlertRulesEntry',
  data () {
    return {
      loader: null,
      submitted: false,
      optionsAccount: null,
      ruleList: [],
      currentRule: null,
      /* Form Values */
      selectedAccount: null,
      ruleName: '',
      ruleItemType: '',
      ruleItemCode: '',
      ruleOperator: '',
      ruleValue: 0,
      notifyToValue: '',
      /* Options */
      optionsItemType: null,
      optionsOperator: null
    }
  },
  created () {
    this.optionsAccount = Array.from(this.userClients)
    this.selectedAccount = this.optionsAccount.filter(item => item.code === this.$route.params.accountCode)[0]

    if (this.$route.params.ruleCode) {
      this.getRuleData(this.$route.params.ruleCode)
    } else {
      this.getRuleList()
    }

    this.loadSelectData()
  },
  mounted () {
    $(this.$el).find('#numValue').keydown(function (e) {
      // Allow: backspace, delete, tab, escape, enter and .
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
          // Allow: Ctrl/cmd+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl/cmd+C
        (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl/cmd+X
        (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
              // let it happen, don't do anything
        return
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault()
      }
    })
  },
  components: {
    Modal,
    Multiselect
  },
  computed: {
    ...mapGetters([
      'userClients'
    ])
  },
  methods: {
    ...mapActions([
      'fetchAlertRulesItemTypes',
      'fetchAlertRulesOperators',
      'fetchAlertRulesList',
      'saveAlertRule'
    ]),
    loadSelectData () {
      this.fetchAlertRulesItemTypes().then((data) => {
        if (data != null) {
          this.optionsItemType = data.map(item => ({
            code: item.code,
            name: item.text
          }))

          if (this.ruleItemType === '') {
            this.ruleItemType = this.optionsItemType[0].code
          }
        }
      })

      this.fetchAlertRulesOperators().then((data) => {
        if (data != null) {
          this.optionsOperator = data.map(item => ({
            code: item.code,
            name: item.text
          }))

          if (this.ruleOperator === '') {
            this.ruleOperator = this.optionsOperator[0].code
          }
        }
      })
    },
    onAccountSelect (account) {
      this.selectedAccount = account
      this.getRuleList()
    },
    getRuleList () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.fetchAlertRulesList(this.selectedAccount.code)
      .then((data) => {
        if (data != null) {
          this.ruleList = data.map(item => ({
            AccountCode: item.accountCode,
            AlertRuleId: item.alertRuleId,
            Name: item.name,
            AppliesTo: item.appliesTo,
            ItemValue: item.itemValue,
            Operator: item.operator,
            TargetValue: item.targetValue,
            NotifyTo: item.notifyTo ? item.notifyTo : ''
          }))
          this.loader.hide()
        }
      })
    },
    getRuleData (ruleCode) {
      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.fetchAlertRulesList(this.selectedAccount.code).then((data) => {
        if (data != null) {
          this.ruleList = data.map(item => ({
            AccountCode: item.accountCode,
            AlertRuleId: item.alertRuleId,
            Name: item.name,
            AppliesTo: item.appliesTo,
            ItemValue: item.itemValue,
            Operator: item.operator,
            TargetValue: item.targetValue,
            NotifyTo: item.notifyTo ? item.notifyTo : ''
          }))

          let selectedRule = this.ruleList.filter(item => item.AlertRuleId === ruleCode)[0]

          if (selectedRule) {
            this.currentRule = selectedRule
            this.ruleName = this.currentRule.Name
            this.ruleItemType = this.currentRule.AppliesTo
            this.ruleItemCode = this.currentRule.ItemValue
            this.ruleOperator = this.currentRule.Operator
            this.ruleValue = this.currentRule.TargetValue
            this.notifyToValue = this.currentRule.NotifyTo
          }

          this.loader.hide()
        }
      })
    },
    handleSubmit () {
      document.activeElement.blur()

      this.submitted = true

      if (this.selectedAccount && this.ruleName !== '' && this.ruleItemType !== '' && this.ruleItemCode !== '' && this.ruleOperator !== '' && this.ruleValue > 0 && this.validateName() && this.validateEmailString()) {
        this.$bus.$emit('modal-open', {
          title: 'Confirmación',
          description: '¿Desea continuar con ' + (this.currentRule === null ? 'el registro' : 'la actualización') + ' de Regla?',
          type: 'primary',
          confirmText: 'Aceptar',
          cancelText: 'Cancelar',
          confirmBefore: () => {
          },
          confirmAfter: () => {
            this.loader = this.$loading.show({
              loader: 'dots'
            })

            var params = {
              AlertRuleId: this.currentRule ? this.currentRule.AlertRuleId : '',
              AccountCode: this.selectedAccount.code,
              Name: this.ruleName.trim(),
              AppliesTo: this.ruleItemType,
              ItemValue: this.ruleItemCode,
              Operator: this.ruleOperator,
              TargetValue: this.ruleValue,
              NotifyTo: this.notifyToValue
            }

            this.saveAlertRule(params).then((data) => {
              let title, description, type
              if (data.success) {
                title = 'Éxito'
                description = 'Se grabó Regla exitósamente.'
                type = 'success'

                if (params.AlertRuleId === '') {
                  params.AlertRuleId = data.data[0].alertRuleId
                  this.currentRule = params
                  this.ruleList.push(this.currentRule)
                } else {
                  this.currentRule = params

                  let index

                  for (index = 0; index < this.ruleList.length; index++) {
                    const element = this.ruleList[index]

                    if (element.AlertRuleId === this.currentRule.AlertRuleId) {
                      break
                    }
                  }

                  this.ruleList[index] = this.currentRule
                }
              } else {
                title = 'Error'
                description = 'Ocurrió un error al validar o grabar la Regla.'
                type = 'danger'
              }

              this.loader.hide()

              this.$bus.$emit('modal-open', {
                title: title,
                description: description,
                type: type,
                confirmText: 'Aceptar',
                cancelText: null,
                confirmBefore: () => {
                },
                confirmAfter: () => {
                },
                cancelBefore: () => {
                },
                cancelAfter: () => {
                }
              })
            })
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      }
    },
    validateName () {
      let result = true
      let matches

      if (this.currentRule) {
        matches = this.ruleList.filter(item => item.AlertRuleId !== this.currentRule.AlertRuleId)
      } else {
        matches = this.ruleList.slice(0)
      }

      matches.forEach(element => {
        if (element.Name.trim().toLowerCase() === this.ruleName.trim().toLowerCase()) {
          result = false
        }
      })

      if (!result) {
        this.$bus.$emit('modal-open', {
          title: 'Validación',
          description: 'Ya existe una regla con el nombre ingresado.',
          type: 'warning',
          confirmText: 'Aceptar',
          cancelText: null,
          confirmBefore: () => {
          },
          confirmAfter: () => {
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      }

      return result
    },
    validateEmailString () {
      let result = true

      if (this.notifyToValue.trim() !== '') {
        let emailArray = this.notifyToValue.split(';')

        var re = new RegExp('[^@]+@[^@]+\\.[^@]+')

        emailArray.forEach(element => {
          if (!re.test(String(element).toLowerCase())) {
            result = false
          }
        })

        if (!result) {
          this.$bus.$emit('modal-open', {
            title: 'Validación',
            description: 'Alguno de los correos ingresados ',
            type: 'warning',
            confirmText: 'Aceptar',
            cancelText: null,
            confirmBefore: () => {
            },
            confirmAfter: () => {
            },
            cancelBefore: () => {
            },
            cancelAfter: () => {
            }
          })
        }
      } else {
        result = false
      }

      return result
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>
#divAccountSelect, #divSearchSelect{ 
  margin-bottom: 34px;
}

#divAccountSelect, #divSearchSelect{ 
  height: 34px;
}

#divAccountSelect.multiselect__tags, #divSearchSelect .multiselect__tags{ 
  border-radius: 0px !important;
  min-height: 34px;
  height: 34px;
}

#divAccountSelect .multiselect__select{ 
  border-radius: 0px !important;
  height: 34px;
}

#txtEmail {
  resize: none;
}

</style>



// WEBPACK FOOTER //
// AlertRulesEntry.vue?67db6144